
document.addEventListener('DOMContentLoaded', () => {
  function applyExpressRewardIfNeeded() {
    const expressPrize = document.querySelector('.express-prize');
    const activeDiscount = sessionStorage.getItem('activeDiscountCode');

    if (expressPrize) {
      expressPrize.classList.toggle('active', activeDiscount === 'EASTEREXPRESS');
    }
  }
  applyExpressRewardIfNeeded();
  const observer = new MutationObserver(() => {
    applyExpressRewardIfNeeded();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  watchDiscountChanges();
});

function watchDiscountChanges() {
  const CHECK_DELAY = 3200;
  const wrapper = document.querySelector('.styles_Footer__savings__');

  if (!wrapper) return;

  const discountObserver = new MutationObserver(() => {
    setTimeout(() => {
      validateDiscountStillExists();
    }, CHECK_DELAY);
  });

  discountObserver.observe(wrapper, {
    childList: true,
    subtree: true
  });
}

function validateDiscountStillExists() {
  const activeDiscountCode = sessionStorage.getItem('activeDiscountCode');
  const bonusProductData = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
  if (!activeDiscountCode) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const discountStillExists = cart.cart_level_discount_applications?.some(
        d => d.code === activeDiscountCode
      );

      if (!discountStillExists) {
        console.log(`[Egg Hunt] Discount ${activeDiscountCode} removed. Clearing session + bonus.`);

        sessionStorage.removeItem('activeDiscountCode');
        sessionStorage.removeItem('bonusProduct');

        const expressPrize = document.querySelector('.express-prize');
        if (expressPrize) expressPrize.classList.remove('active');

        if (bonusProductData?.discountCode === activeDiscountCode) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: bonusProductData.productId, quantity: 0 })
          }).then(() => {
            if (window.UpCart) UpCart.refreshCart();
            console.log(`[Egg Hunt] Removed bonus product ID ${bonusProductData.productId}`);
          });
        }
      }
    })
    .catch(err => console.warn('Error verifying cart discount:', err));
}

function monitorBonusRewardSync() {
  const CHECK_INTERVAL = 3600;

  setInterval(() => {
    const bonusData = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
    const activeDiscountCode = sessionStorage.getItem('activeDiscountCode');

    if (!bonusData) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const discounts = cart.cart_level_discount_applications || [];
        const items = cart.items || [];

        const discountStillExists = discounts.some(d => d.code === bonusData.discountCode);
        const bonusStillInCart = items.some(item => item.variant_id == bonusData.productId);

        // 💥 CASE 1: Discount exists but product was manually removed
        if (discountStillExists && !bonusStillInCart) {
          console.log('[Egg Hunt] Bonus product manually removed. Clearing bonusProduct from session.');
          sessionStorage.removeItem('bonusProduct');
          return;
        }

        // 💥 CASE 2: Discount gone but product still in cart → remove product
        if (!discountStillExists && bonusStillInCart) {
          console.log('[Egg Hunt] Discount missing but bonus product still in cart. Removing product.');

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: bonusData.productId, quantity: 0 })
          }).then(() => {
            if (window.UpCart) UpCart.refreshCart();
            sessionStorage.removeItem('bonusProduct');
            sessionStorage.removeItem('activeDiscountCode');

            const expressPrize = document.querySelector('.express-prize');
            if (expressPrize) expressPrize.classList.remove('active');
          }).catch(err => console.warn('❌ Failed to remove bonus product:', err));
        }
      })
      .catch(err => console.warn('❌ Failed to check cart for cleanup:', err));
  }, CHECK_INTERVAL);
}


